import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { formatDate, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { AdminEarningsService } from "../../services/AdminEarningsService";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { DataMatrixGrid } from "../DataMatrixGrid";
import { EarningsService } from "../../services/EarningsService";
import { IAppState } from "../../store/reducers";
import { IEarnings } from "../../models/Earnings";
import { IGetListRequest } from "../../models";
import { PayrollPensionableEarningService } from "../../services/payrollPensionableEarningService";
import { PayrollPensionableEarningsDialogueSetupFieldsPanel } from "./PayrollPensionableEarningsSetupFieldsPanel";
import { PayrollPensionableEarningsDialogueSetupValidationSchema } from "./validator";
import { PrimeDataGrid } from "../PrimeDataGrid";
import { RemittanceFrequencyService } from "../../services/RemittanceFrequencyService";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IPayrollPensionableEarningList { }
const FEDERAL_EARNINGS_LIST_QUERY_KEY = "earnings-list";

const useEarningses = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["earnings-list", params],
		queryFn: (data) => {

			return PayrollPensionableEarningService.getEarnings(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetEarningsDDL = () =>
	useQuery({
		queryKey: ["Earnings-ddl"],
		queryFn: () => AdminEarningsService.getEarningsDDL(),
		refetchOnWindowFocus: false,
	});
export const PayrollPensionableEarningList: React.FC<
	IPayrollPensionableEarningList
> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [selectedRowData, setSelectedRowData] = useState<any>(undefined);
	const [openProvinceUpdateDialog, setProvinceUpdateDialogOpen] =
		useState(false);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "label",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useEarningses(
		clientIdStore,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const earningsList: any | null = data;

	const { isPending: isPendingEarningsDDL, data: earningsDDLList } =
		useGetEarningsDDL();

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [isLoadingData, setIsLoadingData] = useState(false);
	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroEarnings, setzeroEarnings] = useState(true);
	const [earningsListUpdatedItems, setEarningsListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [earningsId, setEarningsId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkEarningsId, setBulkEarningsId] = useState<any>({});
	const [bulkEarningsDelete, setBulkEarningsDelete] = useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null ? requestParams.sortField : "label",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		if (requestParams.searchQuery !== "") {
			setzeroEarnings(false);
		} else {
			setzeroEarnings(true);
		}
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroEarnings(false);
	};

	const onRowEditClicked = useCallback((params: IEarnings) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/company/earnings/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteEarningsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				earningsId: earningsId,
				navigateToLogout: navigateToLogout,
			};
			deleteEarningsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: IEarnings) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setEarningsId(params.id);
	}, []);

	const onCloseProvinceUpdateHandler = () => {
		setProvinceUpdateDialogOpen(false);
	};

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteEarningsById } = useMutation({
		mutationFn: EarningsService.delEarnings,

		onSuccess: (res: string | IServerError | IResponse | any) => {

			if (res) {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				return queryClient.invalidateQueries({
					queryKey: [FEDERAL_EARNINGS_LIST_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	// dispatch(setSelectedEarnings(clickedRow));
	// dispatch(setSelectedEarningsName(clickedRow));
	// };

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkEarningses } =
		useMutation({
			mutationFn: EarningsService.delBulkEarningses,
			onSuccess: (res: any | string | IServerError | IResponse) => {
				if (typeof res === "object") {
					// remove the cache of the Year fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong.",
						severity: res.status === false ? "error" : "success",
					});

					setBulkEarningsDelete(false);
					return queryClient.invalidateQueries({
						queryKey: [FEDERAL_EARNINGS_LIST_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				setBulkEarningsDelete(false);
			},
			onError: (err: any) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
				setBulkEarningsDelete(false);
			},
		});

	// For Bulk Delete
	const deleteBulkEarningsField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				earningsIds: bulkEarningsId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkEarningses(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			earningsIds: { earningsIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkEarningsId(bulkDeletePayload);
		setBulkEarningsDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					<Button
						onClick={() => onRowMultipleDeleteClicked(selectedItems)}
						variant="contained"
						color="error"
					>
						Delete
					</Button>
				</Box>
			);
		}
		return <></>;
	}, []);

	const upadtedEarningsListItems = useMemo(() => {
		return (
			earningsList &&
			earningsList.items &&
			earningsList?.items.map((item: any) => ({
				...item,
				title: (
					<Link
						to={`/company/earnings/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
					>
						{item.title}
					</Link>
				),
			}))
		);
	}, [earningsList]);



	const formMethods = useForm<any>({
		resolver: yupResolver(
			PayrollPensionableEarningsDialogueSetupValidationSchema
		),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const expandedLabels = ["Earnings", "Pensionable"];
	const expandedPensionableTaxableListOrListItem = "List"; // Special case for "List" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Pensionable" &&
				item.label === expandedPensionableTaxableListOrListItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "Pensionable" && item.label === expandedPensionableTaxableListOrListItem && "/payroll-pensionable-earning/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onProvinceClicked = (selectedOptionLabel: string, params: any) => {

		const selectedProvinceObject = Object.values(params).find(
			(item: any) =>
				item && !Array.isArray(item) && item.name === selectedOptionLabel
		);

		// const selectedProvinceEntry = Object.entries(params).find(
		// 	([_, value]: any) => value.label === selectedOptionLabel
		// );

		// const key:any = selectedProvinceEntry?.[0]; // e.g., "alberta"
		// const value = selectedProvinceEntry?.[1]; // e.g., { label: "ALberta", value: 12 }
		let rowData = {
			id: params.id,
			earningId: params.earningId,
			enable: params.enable,
			effectiveDate: params.effectiveDate,
			endDate: params.endDate,
			province: selectedOptionLabel,
			selectedProvinceObject: selectedProvinceObject,
			ProvinceArray: params.province,
			// provinceObject:[{ [key]: value }],
		};
		setSelectedRowData(rowData);
		setProvinceUpdateDialogOpen(true);
	};

	const submitPayload = async (payload: any) => {
		setIsLoadingData(true);
		try {
			await PayrollPensionableEarningService.create(payload);
			setProvinceUpdateDialogOpen(false);
			queryClient.invalidateQueries({
				queryKey: [FEDERAL_EARNINGS_LIST_QUERY_KEY],
			});
		} catch {
			console.error("Error while submitting data");
		} finally {
			setIsLoadingData(false);
		}
	};

	const onSubmit = async (formData: any) => {

		const selectedProvinceObjectWithUpdatedStatusValue = {
			...selectedRowData.selectedProvinceObject,
			status: formData.enable ? 100 : 200,
		};

		const hasEarningChanged = formData.earningId !== selectedRowData.earningId;
		const hasEffectiveDateChanged =
			formatDate(formData.effectiveDate) !== selectedRowData.effectiveDate;
		let payload;

		if (hasEarningChanged || hasEffectiveDateChanged) {
			let finalProvinceList = selectedRowData.ProvinceArray.map((item: any) => {
				const match = selectedRowData.selectedProvinceObject.name === item.name;
				return match
					? selectedProvinceObjectWithUpdatedStatusValue
					: { ...item, status: 300 };
			});
			payload = {
				earningId: formData.earningId,
				enable: formData.enable,
				province: finalProvinceList,
				effectiveDate: formatDate(formData.effectiveDate),
				endDate: formatDate(formData.endDate),
			};

		} else {
			payload = {
				id: formData.id,
				earningId: formData.earningId,
				enable: formData.enable,
				province: [selectedProvinceObjectWithUpdatedStatusValue],
				effectiveDate: formatDate(formData.effectiveDate),
				endDate: formatDate(formData.endDate),
			};

		}

		await submitPayload(payload);
	};

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return earningsList &&
		earningsList.items &&
		earningsList.items.length === 0 &&
		zeroEarnings === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Pensionable Earnings to proceed`}
			content={`You can add Pensionable Earnings by directly clicking on add Pensionable Earnings button.`}
			testId={"earnings-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Pensionable Earnings"}
			navigateToAdd={"/payroll-pensionable-earning/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={isLoadingData}
					testId="craRamittance-list"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkEarningsDelete === true
							? deleteBulkEarningsField
							: deleteEarningsField
					}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<DataMatrixGrid
					columns={earningsList ? earningsList.headerColumns : []}
					rows={earningsList && earningsList.items ? earningsList.items : []}
					showIndexColumn={true}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					// onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						earningsList && earningsList.total ? earningsList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search..."}
					pageTitle={"Payroll Pensionable Earning"}
					onProvinceClicked={onProvinceClicked}
				// changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
				// 	setzeroEarnings(value)
				// }
				/>
			</Grid>

			{/* Update Pensionable Taxable Earnings By CLicked on Province */}
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<EnhancedDialog
						dialogTitle="Payroll Pensionable Earnings"
						key="dialog-box"
						testId="dialog"
						onCloseHandler={onCloseProvinceUpdateHandler}
						open={openProvinceUpdateDialog}
						dialogContent={
							<PayrollPensionableEarningsDialogueSetupFieldsPanel
								earningsList={earningsDDLList ?? []}
								selectedRecordData={selectedRowData}
								formMethods={formMethods}
							/>
						}
						showdividers={false}
						dialogAction={
							<Grid>
								<EnhancedButtonPrimeReact
									label="Cancel"
									severity="secondary"
									text
									raised
									onClickHandler={onCloseProvinceUpdateHandler}
									style={{ fontSize: "small" }}
								/>
								<EnhancedButtonPrimeReact
									label="Save"
									severity={EnhancedButtonPrimeReactSeverity.Success}
									raised
									type="submit"
									onClickHandler={formMethods.handleSubmit(onSubmit)}
									style={{ marginLeft: "16px", fontSize: "small" }}
								/>
							</Grid>
						}
					/>
				</form>
			</FormProvider>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
